document.addEventListener('DOMContentLoaded', function() {
    // Recursive function to replace text in text nodes only
    function replaceTextWithSpan(node) {
      // Check if the node is a text node
      if (node.nodeType === Node.TEXT_NODE) {
        // Create a regular expression to find all instances of "6FIFTYTWO®"
        const regex = /6FIFTYTWO®/g;

        // If the text contains "6FIFTYTWO®", replace it with a span
        if (regex.test(node.textContent)) {
          // Create a span element
          const span = document.createElement('span');
          span.className = 'logo-dev';
          span.innerHTML = node.textContent.replace(regex, '<span class="logo-dev">6FIFTYTWO®</span>');

          // Replace the text node with the new HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = span.innerHTML;
          while (tempDiv.firstChild) {
            node.parentNode.insertBefore(tempDiv.firstChild, node);
          }
          node.parentNode.removeChild(node);
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Recursively check each child node
        node.childNodes.forEach(replaceTextWithSpan);
      }
    }

    // Start replacing from the body of the document
    replaceTextWithSpan(document.body);
  });